import { Badge } from "reactstrap";
import { DATE_FORMAT_VIEW } from "@src/utility/constants";
import LoadingButton from "@components/ui-components/loading-button";
import LongNameFormatter from "@components/formatters/long-name-formatter";
import capitalize from "lodash/capitalize";
import { getStatusBadge } from "@helpers/utils";
import useDateHandler from "@hooks/use-date-handler";
import { useTranslation } from "react-i18next";

export const decoColumns = ({ handleRowActions }) => {
    const { t } = useTranslation();
    const { dateFormatter } = useDateHandler();

    return [
        {
            name    : "Title",
            selector: (row) => row.title,
            width   : "350px",
            cell    : (row) => (
                <LongNameFormatter
                    content={row.title}
                    className=""
                    id={`title-${row._id}`}
                    max={35}/>
            )
        },
        {
            name    : "Content",
            selector: (row) => row.content,
            width   : "450px",
            cell    : (row) => (
                <LongNameFormatter
                    content={row.content}
                    className=""
                    id={`content-${row._id}`}
                    max={60}/>
            )
        },
        {
            name    : "Created By",
            selector: (row) => row.created_by?.name,
            width   : "220px",
            cell    : (row) => <span>{capitalize(row.created_by?.name)}</span>
        },
        {
            name    : "Created On",
            selector: (row) => row.created_at,
            width   : "220px",
            cell    : (row) => (
                <span>
                    <i className="mdi mdi-calendar me-1 font-medium-2" />
                    {dateFormatter({
                        date    : row?.created_at,
                        formatAs: DATE_FORMAT_VIEW
                    })}
                </span>
            )
        },
        {
            name    : "Status",
            selector: (row) => row.status,
            width   : "150px",
            cell    : (row) => (
                <Badge color={getStatusBadge(row.status)?.color}>
                    {t(getStatusBadge(row.status)?.title)}
                </Badge>
            )
        },
        {
            name: "Actions",
            cell: (row) => (
                <>
                    <LoadingButton
                        className="me-1"
                        color="info"
                        outline
                        id={`${row._id}-edit-button`}
                        icon="pencil"
                        onClick={() => handleRowActions(row, "edit")}/>
                    <LoadingButton
                        outline
                        color="danger"
                        id={`${row._id}-delete-button`}
                        icon="delete"
                        disabled={row.status === "deleted"}
                        onClick={() => handleRowActions(row, "delete")}/>
                </>
            )
        }
    ];
};
